// 拡張JavaScript関数ライブラリ
// https://lodash.com/docs/4.17.15
import _ from 'lodash';

// flatpickr datepickerimport flatpickr from "flatpickr";
import flatpickr from "flatpickr";
const Japanese = require("flatpickr/dist/l10n/ja.js").default.ja;
flatpickr.localize(Japanese);



window.bootstrap = require('bootstrap');
require("./fontawesome");
require('alpinejs');


// パス操作
window.path = require('path');

window.extension = require('./_extension');
window.common = require('./_common');
window.cart = require('./_cart');
window.payment = require('./_payment');
window.user = require('./_user');
window.address = require('./_address');
window.shipper = require('./_shipper');
window.order = require('./_order');
window.upload = require('./_upload');